/* Places the "Selling fast" bar (snippets/rv-selling-fast.liquid) on the product photos, 2026-10-25.
   Phones: just above the bottom of the photo slider (over the photo, above the dots).
   Desktop (2026-10-26, user): fixed over the bottom edge of the photo window, exactly as wide as the photos showing,
   so it stays put on the photos instead of riding the bottom of the screen. Re-measured when the photos change. */
(function () {
  'use strict';
  function place(bar) {
    var host = bar.parentElement;
    var media = host.querySelector('.product__media');
    if (!media) return;
    var bottom = media.getBoundingClientRect().bottom - host.getBoundingClientRect().top;
    bar.style.setProperty('--rv-sf-top', Math.round(bottom - 12 - bar.offsetHeight) + 'px');
    bar.classList.add('rv-sf--placed');
  }
  function placeDesktop(bar) {
    var host = bar.parentElement;
    var media = host.querySelector('.product__media');
    if (!media || !media.offsetHeight) return;
    // The photo window (4 photos, up/down arrows) clips the rest, so its own box is the bottom edge shoppers see.
    var box = media.getBoundingClientRect(), hostBox = host.getBoundingClientRect();
    var left = box.right, right = box.left;
    Array.prototype.forEach.call(media.querySelectorAll('.product__media-item'), function (el) {
      var r = el.getBoundingClientRect();
      if (!el.offsetHeight || r.bottom <= box.top || r.top >= box.bottom) return; // only photos showing in the window
      left = Math.min(left, r.left); right = Math.max(right, r.right);
    });
    if (right <= left) { left = box.left; right = box.right; }
    bar.style.setProperty('--rv-sf-top', Math.round(box.bottom - hostBox.top - bar.offsetHeight) + 'px');
    bar.style.setProperty('--rv-sf-left', Math.round(left - hostBox.left) + 'px');
    bar.style.setProperty('--rv-sf-width', Math.round(right - left) + 'px');
    bar.classList.add('rv-sf--placed');
  }
  function setup() {
    document.querySelectorAll('.rv-sf--desktop').forEach(function (bar) {
      placeDesktop(bar);
      if (bar.__rvSf || !('ResizeObserver' in window)) return;
      bar.__rvSf = true;
      var ro = new ResizeObserver(function () { placeDesktop(bar); });
      ro.observe(bar.parentElement);
      var grid = bar.parentElement.querySelector('.product__media');
      if (grid) ro.observe(grid);
    });
    document.querySelectorAll('.rv-sf--mobile').forEach(function (bar) {
      place(bar);
      if (bar.__rvSf || !('ResizeObserver' in window)) return;
      bar.__rvSf = true;
      var ro = new ResizeObserver(function () { place(bar); });
      ro.observe(bar.parentElement);
      var media = bar.parentElement.querySelector('.product__media');
      if (media) ro.observe(media);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  window.addEventListener('load', setup);
  // Changing color rebuilds the photos (and this bar) - place the new one too.
  var pending;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(setup, 60); })
    .observe(document.body, { childList: true, subtree: true });
})();
// v2
